module.exports = __webpack_public_path__ + "img/image_score_frame.25807abd.png";